import { deploymentsApi, Deployment, type CampaignType } from '../api/deploymentsApi';
import {
  useDeploymentMutation,
  type DeploymentMutationOptions,
} from './_deploymentMutations';

interface CreateInput {
  name: string;
  service_desk_id: number;
  campaign_type: CampaignType;
  start_date: string;
  end_date?: string | null;
}

export const useCreateDeployment = (
  options: DeploymentMutationOptions<Deployment> = {}
) =>
  useDeploymentMutation<CreateInput, Deployment>({
    mutationFn: (input) => deploymentsApi.create(input),
    invalidate: (qc) => qc.invalidateQueries({ queryKey: ['deployments'] }),
    errorLabel: 'Error creating deployment',
    ...options,
  });
